module.exports = __webpack_public_path__ + "b60ffab6ff03dc50ac1c51b316dfd48c.png";